import http from './http';

export default {
  all() {
    return http().get(`/v1/phone_agents`);
  },
  get(id) {
    return http().get(`/v1/phone_agents/${id}`);
  },
  create(data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/phone_agents`, data);
  },
  update(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/phone_agents/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/phone_agents/${id}`);
  },
}
